import { t } from 'i18next';
import * as yup from 'yup';

import { brainsEndpoints } from '@/api/endpoints';

import { LENGTH_XS } from '../constants';
import { createNameFieldSchema } from '../schema-builders';

export const aiAgentSchemas = {
  step1Schema: yup
    .object()
    .shape({ brain_type: yup.string().required(() => t('validation.required')) }),
  step2Schema: yup
    .object()
    .shape({
      name: createNameFieldSchema({ getEndpoint: brainsEndpoints.checkName, max: LENGTH_XS }),
      language: yup.string().required(() => t('validation.required')),
      provider: yup.string(),
      language_model_id: yup.string(),
    }),
};
